module.exports = __webpack_public_path__ + "static/media/galerija_2019 (10).6009b00e.jpg";